import Box from '@/main/components/shared/box';
import KOGCollapse from '@/main/components/shared/kogCollapse/kogCollapse';
import { KeyValueDefault } from '@/main/models/common';
import { PreviousItemAnswersResponse } from '@/main/models/response';
import DirectAssignRow from '@/main/screens/order/reassignOrder/components/directAssignRow/directAssignRow';
import HeaderReassignItem from '@/main/screens/order/reassignOrder/components/reassignPartItem/headerReassignItem';
import SupplierOptionRow from '@/main/screens/order/reassignOrder/components/supplierOptionRow/supplierOptionRow';
import { ReassignPartData } from '@/main/screens/order/reassignOrder/reassignScreenUtils';
import React from 'react';
import { useReassignPartItem } from './useReassignPartItem';
import * as S from './styles';

interface IReassignPartItem {
  index: number;
  partData: ReassignPartData;
  showPrices: boolean;
  guidCompanyBuyer?: string;
  partTypeOptions: KeyValueDefault[];
  showEditControl: boolean;
  showHeader: boolean;
}

function ReassignPartItem({
  index,
  partData,
  showPrices,
  guidCompanyBuyer,
  partTypeOptions,
  showEditControl,
  showHeader
}: Readonly<IReassignPartItem>) {
  const {
    selectedGuid,
    isDirectAssignActive,
    primarySupplier,
    otherSuppliers,
    suppliers,
    isDirectAssignLoading,
    handleSelectSupplier,
    handleToggleDirectAssign
  } = useReassignPartItem({ index, partData, partTypeOptions });

  const renderRow = (
    supplier: PreviousItemAnswersResponse,
    icon?: React.ReactNode,
    toggle?: () => void,
    expanded?: boolean
  ) => {
    const supplierIndex = suppliers.findIndex(
      s =>
        s.guidAnsweredQuoteSupplierItem ===
        supplier.guidAnsweredQuoteSupplierItem
    );
    const isFirstRow =
      supplier.guidAnsweredQuoteSupplierItem ===
      primarySupplier.guidAnsweredQuoteSupplierItem;

    return (
      <S.RowWrapper key={supplier.guidAnsweredQuoteSupplierItem}>
        <SupplierOptionRow
          partIndex={index}
          supplierIndex={supplierIndex}
          part={partData}
          supplierItem={supplier}
          isSelected={selectedGuid === supplier.guidAnsweredQuoteSupplierItem}
          partSelectedGuid={selectedGuid}
          isFirstRow={isFirstRow}
          isDirectAssignActive={isDirectAssignActive}
          isDirectAssignLoading={isDirectAssignLoading}
          onSelect={handleSelectSupplier}
          onToggleDirectAssign={handleToggleDirectAssign}
          collapseIcon={icon}
          onToggleExpand={toggle}
          isExpanded={expanded}
          partTypeOptions={partTypeOptions}
          showPrices={showPrices}
          showEditControl={showEditControl}
        />
      </S.RowWrapper>
    );
  };

  return (
    <Box
      style={{
        marginBottom: '1rem',
        overflowX: 'auto',
        width: '100%'
      }}>
      {showHeader && <HeaderReassignItem showPrices={showPrices} />}
      {otherSuppliers.length > 0 ? (
        <S.CollapseWrapper>
          <KOGCollapse
            isOpenCollapseinitial={false}
            renderHeader={(icon, toggle, expanded) =>
              renderRow(primarySupplier, icon, toggle, expanded)
            }
            content={otherSuppliers.map(item => renderRow(item))}
            showBorder={false}
            forceCollapseTrigger={isDirectAssignActive}
          />
        </S.CollapseWrapper>
      ) : (
        renderRow(primarySupplier)
      )}

      {isDirectAssignActive && (
        <DirectAssignRow
          guidCompanyBuyer={guidCompanyBuyer}
          showPrices={showPrices}
          partIndex={index}
          partTypeOptions={partTypeOptions}
        />
      )}
    </Box>
  );
}

export default React.memo(ReassignPartItem);
